"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExternalServiceType = exports.externalServiceTypes = void 0;
function enumFromConst(values) {
    return Object.fromEntries(values.map((v) => [v, v]));
}
/**
 * Kind of external capability this provider config is for (not our product/feature name).
 * Same vendor can appear under multiple types (e.g. CASHFREE: PAYMENT + PAN_KYC).
 */
exports.externalServiceTypes = [
    'PAYMENT',
    'OTP',
    'PAN_KYC',
    'AADHAAR_KYC',
    'VOIP',
    'TELECOM',
    'WHATSAPP',
    'TICKETING',
];
exports.ExternalServiceType = enumFromConst(exports.externalServiceTypes);
//# sourceMappingURL=ServiceProvider.js.map